export const CREATE_CUSTOMER = "CREATE_CUSTOMER";
export const SET_TOTAL = "SET_TOTAL";
export const CUSTOMERS_RECEIVED = "CUSTOMERS_RECEIVED";
export const SET_CUSTOMER = "SET_CUSTOMER";
export const SET_CUSTOMER_PROPERTY = "SET_CUSTOMER_PROPERTY"
export const RECEIVED_LINK = "RECEIVED_LINK"